import {reactive, computed} from "vue";

export function useFilters(defaultFilters, onApply) {
    // The filters currently applied
    const appliedFilters = reactive({...defaultFilters});
    // The filters being edited by the user
    const filters = reactive({...defaultFilters});

    // Count of active filters (applied != default)
    const filtersActive = computed(() => {
        return Object.keys(defaultFilters).reduce((count, key) => {
            return appliedFilters[key] !== defaultFilters[key] ? count + 1 : count;
        }, 0);
    });

    // Whether the draft differs from applied
    const filtersDirty = computed(() => {
        return Object.keys(defaultFilters).some((key) => filters[key] !== appliedFilters[key]);
    });

    // Apply draft filters
    function applyFilters() {
        Object.keys(defaultFilters).forEach((key) => {
            appliedFilters[key] = filters[key];
        });
        if (typeof onApply === "function") {
            onApply({...appliedFilters});
        }
    }

    // Reset both applied and draft filters to default
    function resetFilters() {
        Object.keys(defaultFilters).forEach((key) => {
            appliedFilters[key] = defaultFilters[key];
            filters[key] = defaultFilters[key];
        });
        if (typeof onApply === "function") {
            onApply({...defaultFilters});
        }
    }

    return {
        defaultFilters,
        appliedFilters,
        filters,
        filtersActive,
        filtersDirty,
        applyFilters,
        resetFilters,
    };
}
